<template>
  <div class="sticky top-0 z-20 flex-shrink-0 flex h-16 bg-white/80 dark:bg-neutral-900/80 backdrop-blur-lg border-b border-gray-200 dark:border-neutral-700">
    <button
      type="button"
      class="px-4 border-r border-gray-200 dark:border-neutral-700 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-orange-500 lg:hidden"
      @click="$emit('toggle-sidebar')"
    >
      <span class="sr-only">Abrir sidebar</span>
      <i class="pi pi-bars text-lg"></i>
    </button>
    
    <div class="flex-1 px-4 flex justify-between items-center">
      <div class="flex-1 flex">
        <!-- Search pode ser adicionado aqui futuramente -->
      </div>
      
      <div class="ml-4 flex items-center md:ml-6 space-x-4">
        <!-- Theme Toggle -->
        <ThemeToggle />
        
        <!-- Profile dropdown -->
        <div class="ml-3 relative">
          <div class="flex items-center space-x-3 px-3 py-2 rounded-lg hover:bg-gray-100 dark:hover:bg-neutral-800">
            <img
              class="h-8 w-8 rounded-full ring-2 ring-white dark:ring-neutral-900"
              :src="user?.avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(user?.name || 'User')}&background=FF6600&color=fff`"
              :alt="user?.name"
            />
            <div class="hidden md:block">
              <div class="text-sm font-medium text-gray-900 dark:text-white">
                {{ user?.name }}
              </div>
              <div class="text-xs text-gray-500 dark:text-gray-400">
                {{ user?.email }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores/auth'
import ThemeToggle from '@/components/ui/ThemeToggle.vue'

defineEmits<{
  'toggle-sidebar': []
}>()

const authStore = useAuthStore()
const { user } = storeToRefs(authStore)
</script>